export const PAYPAL_TAB = "paypal"
export const STRIPE_TAB = "stripe"
export const POWERTRANZ_TAB = "powertranz"
